// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/metrics/v1/metrics.proto" (package "c1.api.metrics.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { MetricsService } from "./metrics";
import type { GetYearInReviewResponse } from "./metrics";
import type { GetYearInReviewRequest } from "./metrics";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { MetricsServiceGetResponse } from "./metrics";
import type { MetricsServiceGetRequest } from "./metrics";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.metrics.v1.MetricsService
 */
export interface IMetricsServiceClient {
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: MetricsServiceGetRequest, options?: RpcOptions): UnaryCall<MetricsServiceGetRequest, MetricsServiceGetResponse>;
    /**
     * @generated from protobuf rpc: GetYearInReview
     */
    getYearInReview(input: GetYearInReviewRequest, options?: RpcOptions): UnaryCall<GetYearInReviewRequest, GetYearInReviewResponse>;
}
/**
 * @generated from protobuf service c1.api.metrics.v1.MetricsService
 */
export class MetricsServiceClient implements IMetricsServiceClient, ServiceInfo {
    typeName = MetricsService.typeName;
    methods = MetricsService.methods;
    options = MetricsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: MetricsServiceGetRequest, options?: RpcOptions): UnaryCall<MetricsServiceGetRequest, MetricsServiceGetResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<MetricsServiceGetRequest, MetricsServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetYearInReview
     */
    getYearInReview(input: GetYearInReviewRequest, options?: RpcOptions): UnaryCall<GetYearInReviewRequest, GetYearInReviewResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetYearInReviewRequest, GetYearInReviewResponse>("unary", this._transport, method, opt, input);
    }
}
